<header class="tt-ai-chat-header">
    <button type="button" class="tt-ai-chat-header__button" aria-label="Show conversations" title="Show conversations" [attr.aria-expanded]="showChats" (click)="toggleChats.emit()">
        <i class="far fa-th-list fa-fw" aria-hidden="true"></i>
    </button>

    <button type="button" class="tt-ai-chat-header__button" aria-label="New conversation" title="New conversation" (click)="newChat.emit()">
        <i class="far fa-edit fa-fw" aria-hidden="true"></i>
    </button>

    <div class="tt-ai-chat-header__heading">
        <h2>
            <ng-container *ngIf="selectedChat?.ai_chat_name; else defaultTitle">{{ selectedChat?.ai_chat_name }}</ng-container>
            <ng-template #defaultTitle><span ttTranslateWord="ai_chat"></span></ng-template>
        </h2>
        <ng-container *ngIf="models$ | async as models">
            <span *ngIf="getSelectedModelName(models) as modelName">{{ modelName }}</span>
        </ng-container>
    </div>

    <button *ngIf="canOpenInModal" type="button" class="tt-ai-chat-header__button" aria-label="Open AI chat in dialog" title="Open AI chat in dialog" (click)="openInModal.emit()">
        <i class="far fa-external-link-alt fa-flip-horizontal fa-fw" aria-hidden="true"></i>
    </button>

    <button *ngIf="canEditConfiguration" type="button" class="tt-ai-chat-header__button" aria-label="AI configuration" title="AI configuration" (click)="configuration.emit()">
        <i class="far fa-cog fa-fw" aria-hidden="true"></i>
    </button>
</header>
